import APIKit from "../Allapis/Apikit/apikit";

export const getSubscriptions = async(params)=>{
    try{
    const endpoint =  `/subscriptions` ;
    const { name,  introducerId, amount,shareClassType } = params;
    const res = await APIKit.get(endpoint,{
        params: {
          name,
          introducerId,
          amount,
          shareClassType
        },
      })
      return res.data;
    }catch(error){
    console.log(error)
    return [];
}
}

export const getSubscriptionDetails = async (id) => {
    try {
      const url = `/subscriptions/${id}`;
      const result = await APIKit.get(url);
      return result.data;
    } catch (e) {
      console.log(e);
      return e.response ? e.response.data : e;
    }
  }